import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ChatList } from 'pages/chat/ChatList';
import { ChatRoom } from 'pages/chat/ChatRoom';
import { ChatParticipants } from 'pages/chat/ChatParticipants';
import './App.css';

function App() {
    return (
        <BrowserRouter>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Navigate to="/chat" replace />} />
                    <Route path="/chat" element={<ChatList />} />
                    <Route path="/chat/room/:roomId" element={<ChatRoom />} />
                    <Route path="/chat/participants/:roomId" element={<ChatParticipants />} />
                </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;
